import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import ModalColumns from './modalColumns';
import Help from '../../../generics/help';
import { donationTypeExtraction } from '../../../../libs/services';

const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
require( 'datatables.net-buttons/js/buttons.html5.min' );
window.JSZip = jzip;

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../../../config');
var report = require('../../../generics/report_head');

class DonationRegister extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.searching = this.searching.bind(this);
		this.isValidForm = this.isValidForm.bind(this);
		this.showCtrlError = this.showCtrlError.bind(this);
		this.checking = this.checking.bind(this);

		this.showColumn = this.showColumn.bind(this);
		this.getColumns = this.getColumns.bind(this);
		this.selectColumns = this.selectColumns.bind(this);
		this.changeColumns = this.changeColumns.bind(this);

		this.getConvokePlace = this.getConvokePlace.bind(this);
		this.getNationalCenter = this.getNationalCenter.bind(this);
		this.getWorkSession = this.getWorkSession.bind(this);
		this.getDonationsType = this.getDonationsType.bind(this);

		this.saveColumnSelected = this.saveColumnSelected.bind(this);

		this.setTable = this.setTable.bind(this);
		this.dateCompare = this.dateCompare.bind(this);


		this.state = {
			health_facilities_id:"all",
			health_facilities: [],

			extraction_type_id:"all",
			extraction_type:[],
			extraction_type_name:"",

			donation_type_id:"all",
			donations_type:[],
			donation_type_name:"",

			search_by:"all",

			start_date 	: "",
			end_date 	: "",
			start_folio:"",
			end_folio:"",

			convoke_places:[],
			convoke_places_id:"all",
			convoke_places_name:"",

			national_centers: [],
			national_center_id: "all",
			national_center_name: "",

			listado:[],

			change_check: false,

			//test datatable to export
			columns:[],
			columns_default:[],
			filename:"",
			work_sessions:[],
			work_session_id:"all",
			work_session_name:"",

			sex:"all",
			sex_name:"",

			tbl_width: "",
			apto:"0",
			no_apto:"0",
			sin_hc:"0",
			total:"0",
			date_hour:"",
			medical:"",
		}
	}

	componentWillMount(){
		var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

		this.setState({
			//health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			medical:(medical.lastname1 !== null ? medical.lastname1 : "")+' '+
					(medical.lastname2 !== null ? medical.lastname2 : "")+' '+medical.names
		});

		if(!this.props.hiddeToReport){
			this.props.reload();
		}

		var path = this.props.match.path.replace('/', '');

		switch(path){
			case 'donation_summary':
				this.setState({
					filename: "Resumen de Donaciones"
				});
				break;
			case 'donation_register':
				this.setState({
					filename: "Donaciones Registradas"
				});
				break;
		}
	}

	async componentDidMount(){
		this.props.waiting.handleShow('Cargando...');
		this.getColumns('inicial');

		this.getWorkSession();

		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			var aux = response.split('|');
			var date = aux[0].split("/");
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				start_date:date[2]+'-'+date[1]+'-'+date[0],
				end_date:date[2]+'-'+date[1]+'-'+date[0],
				date_hour:aux[0]+' '+hours,
			});
		})

		fetch(Config.default.apiGateway.URL+'health_facilities', {
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					health_facilities: response
				});
			}
		});

		this.getConvokePlace();

		this.getNationalCenter();

		let aux_resp = await donationTypeExtraction("no_cells");
        if(aux_resp !== undefined){
            this.setState({
                extraction_type: aux_resp
            });
        }

		this.getDonationsType();
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	getColumns(start){
		fetch(Config.default.apiGateway.URL+'list_show?option=groupByList&menu=donors_report',{
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({columns:[]});

				response.map((res)=>{
					if(res.list_name === 'DONACIONES REGISTRADAS'){
						res.columns.map((col, i)=>{
							if(col.active){
								this.setState({
									columns: [...this.state.columns, {
										title: col.column_name === 'DONACIÓN NÚMERO' ? 'No. DONACIÓN' : col.column_name,
										visible: true
									}]
								});
							}else{
								this.setState({
									columns: [...this.state.columns, {
										title: col.column_name === 'DONACIÓN NÚMERO' ? 'No. DONACIÓN' : col.column_name,
										visible: false
									}]
								});
								
								
							}
						})
					}
						
				});

				if(start === 'inicial'){
					setTimeout(()=>{
						this.setTable();
					}, 500);
				}	
			}
		});
	}

	changeColumns(cols){
		var aux = [];
		var active = 0;

		cols.map((c, i)=>{
			return c.active ?
				active++
			: null
		});

		if(active > 9 && active <= 13){
			this.setState({
				tbl_width: "reg-13"
			});
		}
		
		if(active > 13 && active <= 17){
			this.setState({
				tbl_width: "reg-17"
			});
		}
		if(active > 17 && active <= 21){
			this.setState({
				tbl_width: "reg-21"
			});
		}
		if(active > 21){
			this.setState({
				tbl_width: "reg-25"
			});
		}
		if(active > 7 && active < 10){
			this.setState({
				tbl_width: "reg-9"
			});
		}
		if(active < 8){
			this.setState({
				tbl_width: ""
			});
		}
				

		cols.map((c, i)=>{
			return c.active ?
				aux.push({
					title: c.column_name,
					visible: true
				})
			: aux.push({
				title: c.column_name,
				visible: false
			})
		});

		this.setState({
			columns:aux
		});
	}

	setTable(){

		var page = '';
		var orientation = '';
		var font = '';
		var num = 0;
		var fechas = "Información Del: "+(this.state.start_date !== "" ? moment(this.state.start_date).format("DD/MM/YYYY"): '')+ 
					" Al: "+(this.state.end_date !== "" ? moment(this.state.end_date).format("DD/MM/YYYY") : '') 

		this.state.columns.map((c)=>{
			if(c.visible)
				num += 1
		})
		if(num < 11){
			page = 'A4';
			orientation = 'portrait';
			font = 6;

		}else if(num > 10 && num < 20){
			page = 'A4';
			orientation = 'landscape';
			font = 5
		}else{
			page = 'A4';
			orientation = 'landscape';
			font = 4
		}

		this.$el = $(this.el);
		var uniqueColumns = [];
		var seenColumns = {};
		this.state.columns.map((c)=>{
			var key = (c.title || '').toString().trim().toLowerCase();
			if(!seenColumns[key]){
				seenColumns[key] = true;
				uniqueColumns.push(c);
			}
			return null;
		});
		var rowLength = (this.state.listado && this.state.listado.length > 0 && Array.isArray(this.state.listado[0])) ?
			this.state.listado[0].length
		: uniqueColumns.length;
		var safeColumns = uniqueColumns.slice(0, rowLength);

		var table = this.$el.DataTable({
			dom: 'Bfrtip',
			buttons: [
				{
                	extend: 'excelHtml5',
					title: this.state.filename,
					exportOptions: {
						columns: ':visible'
					}
            	},
            	{
                	extend: 'pdfHtml5',
                	exportOptions:{
                		columns: ':visible'
                	},
                	title: this.state.filename,
                	orientation: orientation,
                	pageSize: page,
                	customize: (doc)=> { 
                		doc.content.unshift({
							image: this.props.header_document,
							alignment:'center',
							width:this.props.w_head
						});

						doc.content.splice(2, 0, {text: fechas, margin:[10,0,0,10] })
						
						doc.content.splice(3, 0, {
							columns:[
								this.state.convoke_places_id !== "all" ?
									{text: 'Lugar de Colecta', width:'10%'}
								: {text:"", width:0},
								this.state.convoke_places_id !== "all" ?
									{text: this.state.convoke_places_name, bold:1, margin:[0,0,0,10] }
								: {text:"", width:0},

								this.state.work_session_id !== "all" ?
									{text: 'Sesión', width:'8%'}
								: {text:"", width:0},
								this.state.work_session_id !== "all" ?
									{text: this.state.work_session_name, bold:1, margin:[0,0,0,10]}
								: {text:"", width:0},

								this.state.national_center_id !== "all" ?
									{text: 'Centro Paciente', width:'10%'}
								: {text:"", width:0},
								this.state.national_center_id !== "all" ?
									{text: this.state.national_center_name, bold:1, margin:[0,0,0,10] }
								: {text:"", width:0},

								this.state.extraction_type_id !== "all" ?
									{text: 'Extracción', width:'8%'}
								: {text:"", width:0},
								this.state.extraction_type_id !== "all" ?
									{text: this.state.extraction_type_name, bold:1, margin:[0,0,0,10]}
								: {text:"", width:0},

								this.state.donation_type_id !== "all" ?
									{text: 'Donación', width:'8%'}
								: {text:"", width:0},
								this.state.donation_type_id !== "all" ?
									{text: this.state.donation_type_name, bold:1, margin:[0,0,0,10]}
								: {text:"", width:0},

								this.state.sex !== "all" ?
									{text: 'Genero', width:'8%'}
								: {text:"", width:0},
								this.state.sex !== "all" ?
									{text: this.state.sex_name, bold:1, margin:[0,0,0,10]}
								: {text:"", width:0},

							]
						});

            			doc.content[5] = {
            				columns:[
								{width:'60%', text:''},
								{
									width:'5%',
									text:'Aptos: ',
									fontSize:7,
									bold:true,
									margin:[0,10,0,10]
								},
								{
									width:'3%',
									text:this.state.apto,
									fontSize:7,
									margin:[0,10,0,10]
								},
								{
									width:'7%',
									text:' No Aptos: ',
									fontSize:7,
									bold:true,
									margin:[0,10,0,10]
								},
								{
									width:'3%',
									text:this.state.no_apto,
									fontSize:7,
									margin:[0,10,0,10]
								},
								{
									width:'5%',
									text:' Sin HC: ',
									fontSize:7,
									bold:true,
									margin:[0,10,0,10]
								},
								{
									width:'3%',
									text:this.state.sin_hc,
									fontSize:7,
									margin:[0,10,0,10]
								},
								{
									width:'5%',
									text:' Total: ',
									fontSize:7,
									bold:true,
									margin:[0,10,0,10]
								},
								{
									width:'3%',
									text:this.state.total,
									fontSize:7,
									margin:[0,10,0,10]
								}
							]
            			}
                		
                		doc.styles.tableHeader.fontSize = font;
                		doc.defaultStyle.fontSize = font; //2,3,4,etc doc.styles.tableHeader.fontSize = 1; //2, 3, 4, etc 
                		doc.footer = {text: this.state.date_hour+'\t-\t'+this.state.medical, alignment: 'right',margin: [ 0, 0, 50, 0 ]};
                		
                	} 
            	},
            ],
			data: this.state.listado,
			columns:safeColumns,
			
			oLanguage:{
				"sProcessing":"Procesando...",
				"sLengthMenu":"Mostrar _MENU_ registros",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfo":"Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
				"sInfoEmpty":"Mostrando registros del 0 al 0 de un total de 0 registros",
				"sInfoFiltered":"(filtrado de un total de _MAX_ registros)",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando...",
				"oPaginate":{
					"sFirst":"Primero",
					"sLast":"Último",
					"sNext":"Siguiente",
					"sPrevious":"Anterior"},
					"fnInfoCallback":null,
			},
			paging:false,
			responsive:true,
			searching: false,
			scrollY:"32em",
			scrollX: true,
			autoWidth: false,
			info:false,
		});

		if (table.rows().indexes().length === 0 ) {
			table.buttons('.buttons-html5').disable();
		}else {
			table.buttons('.buttons-html5').enable();
		}
	}

	handleChange(e){
		this.setState({
			[e.target.name]: e.target.value
		});

		var control = document.getElementById(e.target.name);
		
		if(control.required && control.className.includes('error')){
			control.classList.remove('error');
		}

		if(e.target.name === 'health_facilities_id'){
			setTimeout(()=>{
				this.getConvokePlace();
				this.getWorkSession();
				this.getNationalCenter();
			}, 500);		
		}else if(e.target.name === 'convoke_places_id'){
			this.setState({
				convoke_places_name: e.target.options[e.target.selectedIndex].text
			})
		}else if(e.target.name === 'national_center_id'){
			this.setState({
				national_center_name: e.target.options[e.target.selectedIndex].text
			})
		}else if(e.target.name === 'work_session_id'){
			this.setState({
				work_session_name: e.target.options[e.target.selectedIndex].text
			})
		}else if(e.target.name === 'extraction_type_id'){
			this.setState({
				extraction_type_name: e.target.options[e.target.selectedIndex].text
			})
		}else if(e.target.name === 'donation_type_id'){
			this.setState({
				donation_type_name: e.target.options[e.target.selectedIndex].text
			})
		}else if(e.target.name === 'sex'){
			this.setState({
				sex_name: e.target.options[e.target.selectedIndex].text
			})
		}
	}

	searching(){
		if(this.isValidForm()){
			var obj = {
				convoke_places_id : this.state.convoke_places_id, 
				work_sessions_id:this.state.work_session_id,
				start_date:this.state.start_date,
				end_date:this.state.end_date,
				search_by:this.state.search_by,
				extraction_type_id:this.state.extraction_type_id,
				donation_type_id:this.state.donation_type_id,
				sex:this.state.sex,
				apto:"0",
				no_apto:"0",
				sin_hc:"0",
				total:"0",
				health_facilities_id:this.state.health_facilities_id,
				national_center_id: this.state.national_center_id
			};
			
			this.props.waiting.handleShow('Buscando...');
			fetch(Config.default.apiGateway.URL+'reports/donations_registered',{
				method: 'POST',
				body:JSON.stringify(obj),
				headers: new Headers({
					'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			}).then(res => {
				this.props.waiting.handleClose();
				if(res.ok){
					return res.json();
				}else{
					res.text().then((msg)=>{
						swal('Error', msg, 'error');
					});
				}
			}).then(response => {
				if(response !== undefined){

					this.setState({
						listado: [],
					});

					var list = [];
					response.res.map((r)=>{
						var obj = [
							r.donor_name,
							r.donor_number,
							r.ife_number || "",
							r.group_rh,
							r.phenotypes !== null ? r.phenotypes : "",
							r.patient_name,
							r.hf_name,
							r.home_phone,
							r.work_phone,
							r.cellphone,
							r.email,
							r.address !== null ? r.address : "",
							r.barrio !== null ? r.barrio : "",
							r.cp !== null ? r.cp : "",
							r.municipio !== null ? r.municipio : "",
							r.state !== null ? r.state : "",
							r.bag_type,
							r.enought_blood,
							r.medical_staff !== null ? r.medical_staff : "",
							r.enable,
							r.donation_number,
							r.donation_date !== null && r.donation_date !== "" ?
								moment(r.donation_date).format('DD/MM/YYYY')
							: "",
							r.donation_hour !== "" && r.donation_hour !== null ?
								moment(r.donation_hour, 'H:mm').format('HH:mm') 
							: "",
							r.donation_type,
							r.convoke_place_name !== null ? r.convoke_place_name : "",
							r.incidents_refused, 
							r.init_gr_rh,
							r.extraction_type,
							r.sex,
							r.donor_age,
							r.health_service,
							r.nss,
							r.donor_birthday,
							r.offer_id
						];

						list.push(obj);
					});
					
					console.log(this.state.columns, list)
					setTimeout(()=>{
						this.props.waiting.handleShow('Cargando...');
						this.$el = $(this.el);
						this.$el.DataTable().destroy();
						this.$el.empty();
					}, 500);

					setTimeout(()=>{
						this.props.waiting.handleClose();
						this.setTable();
					}, 1000);

					this.setState({
						listado: list,
						apto:response.aptos,
						no_apto:response.no_aptos,
						sin_hc:response.sin_hc,
						total:response.total
					});
					
				}
			});
		
			
		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

	dateCompare(){
		var ini = moment(this.state.start_date);
		var fin = moment(this.state.end_date);
		var date_ok = true;

		if(ini !== 'Invalid date' && fin !== 'Invalid date'){
			if(fin < ini){
				date_ok = false;
				document.getElementById('end_date').classList.add('error');
			}else{
				document.getElementById('end_date').classList.remove('error');
			}
		}else{
			date_ok = false;
		}		

		return date_ok;
	}

	isValidForm() {
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		    	
		   
		  	}
	    });	    

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	checking(e){
		if(this.state.change_check){
			this.setState({
				change_check: false,
				health_facilities_id: 'all',// sessionStorage.getItem('health_facilities_id'),
			});
		}else{
			this.setState({
				change_check: true,
			});
		}
	}

	showColumn(column_name){
    	var i =0;
      	for(i =0; i < this.state.columns.length;i++){
        	if(this.state.columns[i].column_key === column_name && this.state.columns[i].active){
          		return false;
        	}
      	} 
    	
    	return true;
 	}

 	getConvokePlace(){
 		var health = this.state.health_facilities_id;
 		
 		if(sessionStorage.getItem('matriz') === '1' && health === sessionStorage.getItem('health_facilities_id')){
 			health = 'all';
 		}

 		fetch(Config.default.apiGateway.URL+'convoke_places/by_hf?health_facilities_id='+health, {
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					convoke_places: response
				});
			}
		});
 	}

	getNationalCenter(){
		var health = this.state.health_facilities_id;
		
		if(sessionStorage.getItem('matriz') === '1' && health === sessionStorage.getItem('health_facilities_id')){
			health = 'all';
		}

		fetch(Config.default.apiGateway.URL+'national_centers?option=origin_patients&health_facility='+health, {
		   method: 'GET',
		   headers: new Headers({
			   'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
			   'Accept'		: 'application/json',
			   'Content-Type'	: 'application/json'
		   })
	   }).then(res => {
		   if(res.ok){
			   return res.json();
		   }else{
			   res.text().then((msg)=>{
				   swal('Error', msg, 'error');
			   });
		   }
	   }).then(response => {
		   if(response !== undefined){
			   this.setState({
				   national_centers: response
			   });
		   }
	   });
	}

 	getWorkSession(){ 		
		fetch(Config.default.apiGateway.URL+'work_sessions/actives?health_facilities_id='+sessionStorage.getItem('health_facilities_id'), {
 			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
 		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					work_sessions: response
				});
			}
		});
 	}

 	getDonationsType(){
 		fetch(Config.default.apiGateway.URL+'donation_type/actives', {
 			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
 		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					donations_type: response
				});
			}
		});
 	}

 	selectColumns(){
 		if(this.isValidForm()){
			if(this.dateCompare()){
				 this.modal_columns.handleShow();
			}else{
				swal('Error', 'La Fecha Hasta debe ser mayor o igual a Fecha Desde', 'error');
			}
 		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
 	}

 	saveColumnSelected(cols){
 		var obj = [];

 		cols.map((c)=>{
 			obj.push({id:c.id, active:c.active})
 		});
 		this.props.waiting.handleShow('Actualizando...');
 		fetch(Config.default.apiGateway.URL+'list_show/update_values', {
 			method:'POST',
 			body:JSON.stringify(obj),
 			headers: new Headers({
 				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
 				'Accept'		: 'application/json',
 				'Content-Type'	: 'application/json'
 			})
 		}).then(res => {
 			this.props.waiting.handleClose();
 			if(res.ok){
 				return res.json();
 			}else{
 				res.text().then((msg)=>{
 					swal('Error', msg, 'error');
 				});
 			}
 		}).then(response => {
 			if(response !== undefined){
				 this.changeColumns(cols);
				 
		 		this.searching();
 			}
 		})
 	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{session} ->
					{t('sidebar.nav.reports.MAIN')} ->
					Donantes ->
					{t('sidebar.nav.reports.donation_register')}
					</h5>
				</div>
				
				<Help 
					{...this.props}
		            menu={"help_donors"} 
		            submenu={"help_donations_registered"}  />
				<div className="form-group" style={{paddingLeft:"0.5em"}}>
					<div className="col-xs-12">
						<form noValidate>
							<div className="col-xs-12 col-sm-2" style={{borderRight:"1px solid #e0e0e0"}}>
								<div className="form-group">
									<span className="span-min">Centro</span>
									<select type="text" name="health_facilities_id" id="health_facilities_id" 
										value={this.state.health_facilities_id} disabled={!this.state.change_check} onChange={this.handleChange}
										className="form-control" required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.health_facilities.map((h, i)=>{
											return <option key={i} value={h.id}>
												{h.name}
											</option>
										})}
									</select>

									<input type="checkbox" name="change_center" id="change_center" 
										style={{marginRight:"5px"}} onChange={this.checking}
										checked={this.state.change_check} />
									<span className="span-min">Cambiar</span>
								</div>
								<div className="form-group">
									<span className="span-min">Lugar de Colecta</span>
									<select className="form-control" name="convoke_places_id" id="convoke_places_id"
										value={this.state.convoke_places_id} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.convoke_places.map((c, i)=>{
											return <option key={i} value={c.id}>
												{c.name}
											</option>
										})}
									</select>
								</div>

								<div className="form-group">
									<span className="span-min">Sesión</span>
									<select className="form-control" name="work_session_id" id="work_session_id" 
										value={this.state.work_session_id} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.work_sessions.map((w, i)=>{
											return <option key={i} value={w.type}>
												{w.value}
											</option>
										})}
									</select>
								</div>

								<div className="form-group">
									<span className="span-min">Fecha Desde</span>
									<input type="date" className="form-control hour-input" name="start_date" id="start_date"
										value={this.state.start_date} onChange={this.handleChange} required />
								</div>
								<div className="form-group">
									<span className="span-min">Fecha Hasta</span>
									<input type="date" className="form-control hour-input" name="end_date" id="end_date"
										value={this.state.end_date} onChange={this.handleChange} required />
								</div>
								<div className="form-group">
									<span className="span-min">Centro Paciente</span>
									<select className="form-control" name="national_center_id" id="national_center_id"
										value={this.state.national_center_id} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.national_centers.map((c, i)=>{
											return <option key={i} value={c.id}>
												{c.name}
											</option>
										})}
									</select>
								</div>

								<div className="form-group">
									<span className="span-min">Mostrar</span>
									<select className="form-control" name="search_by" id="search_by"
										value={this.state.search_by} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										<option value="accept">APTOS</option>
										<option value="reject">NO APTOS</option>
									</select>
									
								</div>
								<div className="form-group">
									<span className="span-min">Tipo de Extracción</span>
									<select className="form-control" name="extraction_type_id" id="extraction_type_id"
										value={this.state.extraction_type_id} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.extraction_type.map((don, i)=>{
											return <option key={i} value={don.id}>
												{don.donation_type_process}
											</option>
										})}
									</select>
								</div>
								<div className="form-group">
									<span className="span-min">Tipo de Donación</span>
									<select className="form-control"  name="donation_type_id" id="donation_type_id"
										value={this.state.donation_type_id} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.donations_type.map((d, i)=>{
											return <option key={i} value={d.donation_type.id}>
												{d.lookup_value}
											</option>
										})}
									</select>
								</div>
								<div className="form-group">
									<span className="span-min">Genero Donante</span>
									<select className="form-control"  name="sex" id="sex"
										value={this.state.sex} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										<option value="HOMBRE">MASCULINO</option>
										<option value="MUJER">FEMENINO</option>
									</select>
								</div>
								<div style={{textAlign:"right"}}>
									<button type="button" className="btn btn-info" onClick={this.selectColumns} style={{fontSize:"1em"}}>
										Buscar
									</button>
								</div>
							</div>

							<div className="col-xs-12 col-sm-10">
								<div className="col-xs-12 form-group" style={{marginTop:"20px"}}>
									<div className="col-xs-12" style={{textAlign: "center",fontWeight: "bold",textDecoration: "underline", fontSize:'16px'}}>
										<span>
											Listado de Donaciones Registradas
										</span>
									</div>
							        {/*<h4>LISTADO DE DONACIONES REGISTRADAS</h4>*/}
									<div><span>{session}</span></div>
									<div>
										{moment(this.state.start_date).format('DD/MM/YYYY')+' - '+
										moment(this.state.end_date).format('DD/MM/YYYY')}
									</div>
									<div></div>

								</div>

								<div className="col-xs-12">
									{this.state.convoke_places_id !== 'all' && this.state.convoke_places_id !== ""?
										<span>
											Lugar de Colecta:  
											<b style={{marginLeft:"5px"}}>{this.state.convoke_places_name}</b>
										</span>	
									:null}

									{this.state.work_session_id !== 'all' && this.state.work_session_id !== ""?
										<span style={{marginLeft:"15px"}}>
											  Sesión:
											<b style={{marginLeft:"5px"}}>{this.state.work_session_name}</b>
										</span>	
									:null}

									{this.state.national_center_id !== 'all' && this.state.national_center_id !== ""?
										<span>
											Centro del Paciente:  
											<b style={{marginLeft:"5px"}}>{this.state.national_center_name}</b>
										</span>	
									:null}

									{this.state.extraction_type_id !== 'all' && this.state.extraction_type_id !== ""?
										<span style={{marginLeft:"15px"}}>
											Extracción: 
											<b style={{marginLeft:"5px"}}>{this.state.extraction_type_name}</b>
										</span>	
									:null}

									{this.state.donation_type_id !== 'all' && this.state.donation_type_id !== "" ?
										<span style={{marginLeft:"15px"}}>
											Donacion:  
											<b style={{marginLeft:"5px"}}>{this.state.donation_type_name}</b>
										</span>	
									:null}

									{this.state.sex !== 'all' && this.state.sex !== "" ?
										<span style={{marginLeft:"15px"}}>
											Genero:  
											<b style={{marginLeft:"5px"}}>{this.state.sex_name}</b>
										</span>	
									:null}
								</div>

								<div className="col-xs-12" id="table-to-pdf">
									<div className="table-responsive">
										<table style={{fontSize:"11px"}} className={this.state.tbl_width} id="table-to-xls" width="100%" ref={el => this.el = el}>
										</table>
									</div>
								</div>
								<div className="col-xs-12 form-group" style={{fontSize:"14px", textAlign:"right"}}>
									<label style={{margin:"0 5px"}}>Aptos:</label>{' '+this.state.apto}
									<label style={{margin:"0 5px"}}>No Aptos:</label>{' '+this.state.no_apto}
									<label style={{margin:"0 5px"}}>Sin HC:</label>{' '+this.state.sin_hc}
									<label style={{margin:"0 5px"}}>Total:</label>{' '+this.state.total}
								</div>
							</div>
						</form>
					</div>
				</div>

				<ModalColumns {...this.props} onRef={ref => (this.modal_columns = ref)}
					saveColumns={this.saveColumnSelected} />
			</div>
		)
	}
}

export default translate('translations') (DonationRegister);
